import { Component, Inject, OnDestroy, OnInit } from '@angular/core';

import { DynamicType } from '../../../thematics/models/dynamic.model';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogRef } from '../dialog/dialog.ref';
import { DIALOG_DATA } from '../dialog/dialog.token';

export type JourneyCheckoutSelectorDialogData = {
  title?: string;
  message?: string;
};

@Component({
  selector: 'app-journey-checkout-selector-dialog',
  templateUrl: './journey-checkout-selector-dialog.component.html',
  styleUrls: ['./journey-checkout-selector-dialog.component.scss'],
})
export class JourneyCheckoutSelectorDialogComponent
  extends DialogComponent<DynamicType, JourneyCheckoutSelectorDialogData>()
  implements OnInit, OnDestroy {
  static override isPopIn = true;
  public readonly DynamicType = DynamicType;

  constructor(
    @Inject(DIALOG_DATA)
    public override readonly data: JourneyCheckoutSelectorDialogData,
    private readonly ref: DialogRef<DynamicType>,
  ) {
    super(ref);
  }

  ngOnInit() {
    super.onInit();
  }

  ngOnDestroy() {
    super.onDestroy();
  }

  selectJourney(journeyType: DynamicType): void {
    super.close(journeyType);
  }

  cancel(): void {
    super.close(undefined);
  }
}
